export function cleanAccessType(access_type = "") {
  return access_type.trim().toLowerCase().replace(/\s+/g, "");
}

export function filterTribeGroupByAccessLevel(
  tribeGroups = [],
  auth_user_id = null,
) {
  return tribeGroups.filter((group) => {
    const groupAccess = cleanAccessType(group.access_type);

    if (groupAccess === "opendiscussion") {
      return true;
    }

    if (groupAccess === "adminonly") {
      const isAdminOrCoach = group.members.some((member) => {
        const user = member.user;
        return (
          user.id === auth_user_id &&
          (member.role.toLowerCase() === "admin" || user.is_coach)
        );
      });
      return isAdminOrCoach;
    }

    return false;
  });
}
